"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");


class Element extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.container = this.root.querySelector(".swiftref-inputs-group");
        this.messageElement = this.root.querySelector("swiftref-message");

        this.initSlots();

    }

    static get observedAttributes() {
        return ["disabled", "message"];
    }

    get message() {
        return this.getAttribute("message");
    }
    set message(message) {
        this.setAttribute("message", message);
    }
    get label() {
        return this.getAttribute("label");
    }
    set label(label) {
        this.setAttribute("label", label);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(disabled) {
        if (disabled) {
            this.setAttribute("disabled", "");
        } else {
            this.removeAttribute("disabled");
        }
    }

    get name() {
        try {
             return this.inputs[0].name;
        } catch (e) {
            return this.getAttribute("name");
        }
    }
    get value() {
        try {
            for (const input of this.inputs) {
                if (!input.disabled && input.checked) {
                    return input.value;
                }
            }
        } catch (e) {
            return this.getAttribute("value");
        }
    }
    // set name(name) {
    //     this.setAttribute("name", name);
    // }

    getInputs() {
        const radios = Array.from(this.querySelectorAll("swiftref-radio-button"));
        const checkboxes = Array.from(this.querySelectorAll("swiftref-checkbox"));
        return radios.concat(checkboxes);
    }

    initSlots () {
        this.inputs = [];
        const isDisable = this.disabled;
        const label = this.textContent.trim();
        if (label) {
            const labelElement = document.createElement("label");
            labelElement.className = "swiftref-inputs-group-label";
            labelElement.innerText = label;
            this.container.appendChild(labelElement);
        }
        let inputs = this.querySelectorAll("swiftref-checkbox");
        for (const checkbox of inputs) {
            this.inputs.push(checkbox);
            checkbox.disabled = isDisable;
            this.container.appendChild(checkbox);
        }
        if (inputs.length === 0) {

            inputs = this.querySelectorAll("swiftref-radio-button");
            const fieldset = document.createElement("fieldset");
            for (let radio of inputs) {
                // this.inputs.push(radio);
                radio.disabled = isDisable;
                fieldset.innerHTML += radio.shadowRoot.innerHTML;
                this.container.appendChild(fieldset);
                // remove slotted elements once have been moved inside the inputs group
                this.removeChild(radio);
            }
            this.inputs = fieldset.querySelectorAll("input");
            const extraStyles = fieldset.querySelectorAll("style");
            for (let i = 1; i < extraStyles.length; i += 1) {
                const extraStyle = extraStyles[i];
                fieldset.removeChild(extraStyle);
            }

        }


        this.container.addEventListener("input", this.onChange.bind(this))
    }


    renderAttribute (name, value) {
        switch (name) {
            case "disabled":
                const isDisable = this.disabled;

                for (const input of this.inputs) {
                    input.disabled = isDisable;
                    if (isDisable) {
                        input.checked = false;
                    }
                }
                break;
            case "message":
                if (value) {
                    this.messageElement.setAttribute("message", value);
                } else {
                    this.messageElement.removeAttribute("message");
                }
                break;
            default:
                break;
        }

    }

    onChange(event) {
        this.dispatchEvent(new CustomEvent('input', {
            detail: {
                originalTarget: event.target
            },
            bubbles: true
        }));
    }


    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-inputs-group", Element);

module.exports = Element;
